import { AppBar, Button, Toolbar, Typography } from "@mui/material";
import { Link } from "react-router-dom";
export default function Header() {
  return (
    <AppBar position="static">
      <Toolbar
        sx={{
          justifyContent: "flex-start",
          gap: 2,
          backgroundColor: "#2e7d32",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            paddingRight: 3,
          }}
        >
          DocMorph AI
        </Typography>

        {/* Navigation buttons, still on the left */}
        <Button color="inherit" component={Link} to="/">
          Home
        </Button>

        <Button color="inherit" component={Link} to="/templateGenerator">
          Template Preview
        </Button>
        <Button color="inherit" component={Link} to="/templateEditor">
          Template Editor
        </Button>
      </Toolbar>

    </AppBar>
  );
}
